<template>
    <div class="wrapper tab-rezept-service">
        <div class="rezept-service-text">
            <span class="new-headline-lg">Fast geschafft!</span>

            <p class="new-text-lg text-color-default">Laden Sie Ihren Diagnosenachweis oder Ihr Rezept in unseren Rezept-Service hoch. Unser Team kümmert sich um den Rest.</p>

            <v-button href="/rezept-service#rezept-service-form" label="Zum Rezept-Service"></v-button>
        </div>

        <figure class="rezept-service-image">
            <img src="imgs/web/svg/img_onboarding_rezept_service.svg" alt="">
        </figure>
    </div>
</template>

<script>
    export default {}
</script>
